import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExpandTableService {
  private id = new Subject<number>();
  public idReferentiel = this.id.asObservable();

  updateId(value: any) {
    this.id.next(value);
  }
}
